import { useLocation, Link } from "react-router-dom";
import { useAllFolders } from "../services/contexts/useFolders";
import "./pdfview.css";
import { contactSupportText } from "./common/utils/constants";

function PDFView() {
  const { allFolders } = useAllFolders();
  const location = useLocation();

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          width: "100%",
          textAlign: "left",
          fontSize: "26px",
          fontWeight: 500,
          cursor: "pointer",
          marginBottom: "10px",
        }}
      >
        <div style={{ textAlign: "left" }}>
          <span className="d-flex" style={{ margin: "" }}>
            {`${location.state.parentPath}/${location.state.currentName}`
              .split("/")
              .slice(1)
              .map((el, idx) => {
                const folderState = allFolders.find((obj) => {
                  return (
                    obj.path ===
                      `${location.state.parentPath}/${location.state.currentName}`
                        .split("/")
                        .slice(0, idx + 1)
                        .join("/") &&
                    obj.folder_name ===
                      `${location.state.parentPath}/${location.state.currentName}`
                        .split("/")
                        .slice(0, idx + 2)
                        .slice(-1)[0]
                  );
                });
                const isDashBoard =
                  folderState?.folder_name === "Dashboard" &&
                  folderState?.path === "root";

                return (
                  <Link
                    key={idx}
                    className="folderLink"
                    to={
                      isDashBoard
                        ? "/Dashboard"
                        : `${location.state.parentPath}/${location.state.currentName}`
                            .split("/")
                            .slice(2, idx + 2)
                            .join("/")
                    }
                    state={{
                      parentPath: folderState?.path,
                      currentFolderId: folderState?.id,
                      currentName: folderState?.folder_name,
                    }}
                  >
                    {el}
                    &gt;
                  </Link>
                );
              })}
            <span className="folderLink">{location.state.documentTitle}</span>
          </span>
        </div>
      </div>

      <div
        style={{
          height: "calc(100vh - 260px)",
          borderRadius: "8px",
          display: "flex",
          flexFlow: "column nowrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <object
          type="application/pdf"
          data={location.state.url}
          className="_g-pdf-view_"
        >
          <div className="_g-pdf-view-failed_">
            Failed to load the file, {contactSupportText}
          </div>
        </object>
      </div>
    </div>
  );
}

export default PDFView;
